/**
 * Kullanıcı menüsü (Dosyalarım): sadece "Sorgularım" satırı.
 * Kayıtlı sorgular /portal/recent-queries/ listesinde gösterilir; menüde önizleme linki yok.
 */
export function MyQueriesMenuApp() {
  return (
    <div className="pp-my-queries-menu">
      <a
        href="/portal/recent-queries/"
        className="pp-collapsible-item"
        title="Sorgularım"
        style={{ textDecoration: 'none' }}
      >
        <i className="fa fa-list" />
        <span>Sorgularım</span>
      </a>
    </div>
  );
}
